import { canadaDeadlineData } from "../../data/canadaTaxData";
import { AlertTriangle } from "lucide-react";

export const CanadaDeadlineStrip = () => (
  <div className="bg-[#FDF1F2] border-y border-[#C8283A]/20 py-3.5 px-6 text-center" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
    <span className="inline-flex items-center gap-2 text-[#0B1829] text-xs sm:text-sm font-semibold">
      <AlertTriangle size={14} className="text-[#C8283A] flex-shrink-0" />
      {canadaDeadlineData.message}{" "}
      <strong className="text-[#C8283A] font-black">April 30, 2026.</strong>{" "}
      Miss it → Penalties start at{" "}
      <strong className="text-[#C8283A]">5% + 1%/month.</strong>{" "}
      Don't wait.
    </span>
  </div>
);
